/* eslint-disable import/prefer-default-export */
import { createContext } from "react";

export const SharedDataContext = createContext({});
export const DataSocketContext = createContext({});
